<template>
    <div>
        <div v-if="error" class="button-custom-alert">{{ error }}</div>

        <!-- Forced deactivation of the purchase button -->
        <button type="submit" class="button button-big button-submit">
            <i class="fa fa-cart-plus"></i> {{ name }}
        </button>
    </div>
</template>

<style lang="scss" scoped>
    .button-custom-alert {
        color: var(--color-red);
        width: 100%;
        text-align: center;
    }

    .button-submit {
        display: block;
        margin: 16px auto;
    }
</style>

<script>
    export default {
        props: {
            name: String,
            error: String,
        },
    }
</script>
